import { render, staticRenderFns } from "./RechnungDeleteDialog.vue?vue&type=template&id=1f7618b8&scoped=true"
import script from "./RechnungDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./RechnungDeleteDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7618b8",
  null
  
)

export default component.exports